// 3rd-party modules
import { message } from 'antd';
import moment from 'moment-timezone';
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import dayjs, { Dayjs } from 'dayjs';
import { TimePicker as AntTimePicker, TimePickerProps as AntTimePickerProps } from "antd";

// project modules

import { convertToSnakecase } from '../../../helpers/objectHelper';
import Input, { InputType } from '../inputs/input';
import Loader from "../loader";
import OptionBar from '../optionBar';
import Checkbox, { CheckboxType } from '../inputs/checkbox';
import Popup from '../popup/popup';
import yup from "../../../plugins/yup";
import { CONSTANTS } from '../../../helpers/defines';


// models
import { ScheduleModel } from './Schedules';
//import  ScheduleModel  from "../../../models/types/ScheduleModel";




type Props = {
  schedule: any;
  closeOnSave?: boolean;
  modalTitle?: string;
  onClose?: () => void;
  onSave?: (schedule: any) => void;
};

export default function ScheduleModal({ schedule = {}, closeOnSave = false, modalTitle = "", onClose, onSave }: Props) {

  const [repeatingDays, setRepeatingDays] = useState<string[]>([]);
  const [fromTime, setFromTime]           = useState<Dayjs|null>( null  );
  const [toTime, setToTime]               = useState<Dayjs|null>( null  );
  const abortController = new AbortController();


  useEffect(() => {

      let sched = schedule
      if(sched == null || sched.activeDays == null || sched.activeDays == "" || sched.activeDays == "all") {
        //setRepeatingDays(["mon","tue","wed","thu","fri","sat","sun"])
        setRepeatingDays([])
      } else {
        setRepeatingDays(sched.activeDays.split(/[,\t ]+/g))
      }
      if(sched != null && sched.fromHour != null ) {
        setFromTime( dayjs( "2025-09-01 " + sched.fromHour + ":" + zeroPad(sched.fromMinute) + " " + sched.fromAmPm ))
        setToTime(   dayjs( "2025-09-01 " + sched.toHour   + ":" + zeroPad(sched.toMinute)   + " " + sched.toAmPm ))
      } else {
        setFromTime( null )
        setToTime(   null )
      }

  }, []);

  const zeroPad = (i:any) => { 
    return ("" + i).length == 1 ? "0" + i : "" + i 
  };

  const onCancel = () => {
    abortController.abort();

    if(onClose) onClose();
  };

  const onDaySelectionChange = (event: any, value: any) => {
    if (repeatingDays.includes(value)) {
      setRepeatingDays(repeatingDays.filter(x => x !== value));
    } else {
      setRepeatingDays([...repeatingDays, value]);
    }
  }

  const onSubmit = async () => {
    let response: {};

    if (!repeatingDays.length) {
      message.error("Please select at least one day.")
      return;
    }

    const tempData: ScheduleModel = {
      id: schedule == null || schedule.id == null ? undefined : schedule?.id,
      fromAmPm: "",
      fromDay: undefined,
      fromHour: "",
      fromMinute: "",
      toAmPm: "",
      toDay: undefined,
      toHour: "",
      toMinute: "",
      activeDays: repeatingDays.join(","),
      enabled: schedule == null || schedule.enabled == null || ("" + schedule.enabled) != "0"  ? "1" : "0",
      repeats: "daily",
    };

    if(fromTime != null && toTime != null) {
      tempData.fromHour = fromTime.format("hh");
      tempData.fromMinute = fromTime.format("mm");
      tempData.fromAmPm = fromTime.format("a");
      tempData.toHour = toTime.format("hh");
      tempData.toMinute = toTime.format("mm");
      tempData.toAmPm = toTime.format("a");
    }





      if (onSave) onSave(tempData);
      
      
      if (closeOnSave) {
        onCancel();
      }

  };

  const dayIsActive = (day:string):boolean => { 
      return repeatingDays.includes(day)
  }




  return (
    <Popup
      title={ modalTitle || `${(!schedule.id ? "New Schedule" : "Edit Schedule")}`}
      onCancel={onCancel}
      onClose={onCancel}
      onSave={onSubmit}
    >
      
      <view data-scroll=''>
        <group data-space="15" data-gap="10" data-direction="column">

          <group data-gap="10" >
            <OptionBar data-length="410">
              <Checkbox checkboxType={CheckboxType.Button} label="Mon" checked={dayIsActive('mon')} onChange={(e) => onDaySelectionChange(e, 'mon')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Tue" checked={dayIsActive('tue')} onChange={(e) => onDaySelectionChange(e, 'tue')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Wed" checked={dayIsActive('wed')} onChange={(e) => onDaySelectionChange(e, 'wed')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Thu" checked={dayIsActive('thu')} onChange={(e) => onDaySelectionChange(e, 'thu')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Fri" checked={dayIsActive('fri')} onChange={(e) => onDaySelectionChange(e, 'fri')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Sat" checked={dayIsActive('sat')} onChange={(e) => onDaySelectionChange(e, 'sat')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Sun" checked={dayIsActive('sun')} onChange={(e) => onDaySelectionChange(e, 'sun')} />
            </OptionBar>
          </group>
          <group data-gap="10">
            <div className="field">
              <div data-position="left" className="data_label"><text data-weight="700">From Time</text></div>
              <AntTimePicker
                name="fromTime"
                //label="From Time"
                needConfirm={false}
                minuteStep={15}
                format="hh:mm a"
                value={ fromTime }
                onChange={ (t) => setFromTime(t) }
              />
            </div>
            <div className="field">
              <div data-position="left" className="data_label"><text data-weight="700">To Time</text></div>
              <AntTimePicker
                name="toTime"
                //label="To Time"
                needConfirm={false}
                minuteStep={15}
                format="hh:mm a"
                value={ toTime }
                onChange={ (t) => setToTime(t) }
              />
            </div>
          </group>
        </group>
      </view>
    </Popup>
  );
}
